import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '@service/shared.service';

@Component({
  selector: 'app-advisor-complaints',
  templateUrl: './advisor-complaints.component.html',
  styles: [
  ]
})
export class AdvisorComplaintsComponent implements OnInit {

  advisorComplaint:any
  advisorId: string = ''
  advisorData: any
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AdvisorComplaintsComponent>,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    if(this.data){
      this.advisorId = this.data.advisorId
      this.advisorData = this.data.advisorData
      this.getAdvisorComplaints()
    }
  }

  getAdvisorComplaints(){
    this.sharedService.getAdvisorComplaint(this.advisorId).subscribe((res)=>{
      if(res.data){
        this.advisorComplaint = res.data
      }
    })
  }

  closeDialog(){
    this.dialogRef.close()
  }
}
